import * as React from 'react';
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@material-ui/core/styles/withStyles';
import {Theme} from '@material-ui/core/styles';
import {
  TextField,
} from '@material-ui/core';
import {PredefinedField} from '../lib/types';
import {TextFieldProps} from '@material-ui/core/TextField';

const styles = (theme: Theme): StyleRules => ({
  formField: {
    width: '100%'
  }
});

// BEFORE YOU ADD PROPS HERE:  Please consider that this is a HELPER to use when building forms where the Primary considerations are the contents of the form definition
// Please consider whther adding a property here is really necessary, or wether it belongs as part of the form definition, itself, or whether you should really be using
// one of the underlying controls directly.
interface Props extends TextFieldProps {
  path: string;
  value: any | undefined;
  fieldDefinition?: PredefinedField;
  errorText?: string;
  onChange?: (newVal: any) => void;
  onCommitChange?: (newVal: any) => void;
  policyMessages?: Array<any>;
  shrink?: boolean;
  customRenderers?: any;
}

type State = {
  value?: any;
};

class CustomFieldRenderer extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      value: props.value
    };
  }

  // componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {
  //   this.setState({value:newProps.value})
  // }c
  // 

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {value} = this.state
    const {fieldDefinition} = this.props

    if(!fieldDefinition){
      console.error("expected definition")
      return null
    }

    const val:any = JSON.stringify(value, null, 2) as any

    return (
      <TextField
        className={classes.formField}
        id="json"
        name="json"
        value={val}
        label={fieldDefinition.title + " (JSON)"}
        InputLabelProps={{
          shrink: true
        }}
        disabled={true}
      />
    )
  }
}

export default  withStyles(styles)(CustomFieldRenderer);

